import { render, staticRenderFns } from "./PageViews.vue?vue&type=template&id=2dd700c8&scoped=true"
import script from "./PageViews.vue?vue&type=script&lang=js"
export * from "./PageViews.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd700c8",
  null
  
)

export default component.exports